export const PROJECT_PERSON_STATE_TYPES = [17, 19, 1];

export const RECRUITMENT_TYPES = [17, 19];
